// extracted by mini-css-extract-plugin
module.exports = {"qcReportTable":"styles_qcReportTable__Q3gru","centered":"styles_centered__1LHAp"};